<script>
    import cart from "../stores/cart";
</script>

<div class="container">
    <div class="mb-5">
        <h1>Η πληρωμή απέτυχε</h1>
        <div class="heading-separator"></div>
    </div>
    <div class="page-icon mb-5">
        <i class="fa fa-exclamation"></i>
    </div>
    <div class="text-center mb-5">
        <p>
            Η συναλλαγή σας δεν ολοκληρώθηκε εξαιτίας ενός σφάλματος.
        </p>
        <p>
            Είτε έχετε ολοκληρώσει την πληρωμή σας είτε έχετε ακυρώσει τη διαδικασία πληρωμής.
        </p>
        {#if $cart.products && $cart.products.length}
            <p>
                <a href="/checkout" class="btn btn-link fw-bold">Επανάληψη πληρωμής</a>
            </p>
        {/if}
    </div>
</div>

